/**
 * VEC-3315 — catálogo de tipos de movimiento del lado del frontend.
 *
 * Espeja las constantes del modelo `ItemStockMovimiento`. Sumar un tipo acá lo hace aparecer a la vez
 * en el filtro y en la columna, que es la razón de que la lista y la traducción vivan juntas y en un
 * solo archivo.
 *
 * Hoy existen CUATRO: `INGRESO` (VEC-3314) y `RESERVA` / `UTILIZACION` / `LIBERACION` (VEC-3316).
 * Los que faltan de los seis que enumera la card los agrega cada card de la épica: DESPACHO y
 * DEVOLUCION en VEC-3317, AJUSTE en VEC-3318, y CONSUMO no tiene card todavía.
 *
 * ⚠️ `RESERVA`, `UTILIZACION` y `LIBERACION` llegan con las DOS ubicaciones iguales (el mismo
 * depósito) porque no transfieren nada: el envase cambia de estado sin moverse. Por eso el backend
 * les manda `esIngreso: null` y la lista no les pinta signo. No es un dato faltante.
 *
 * `etiquetaDeTipo` cae al valor crudo para un tipo que el backend devuelva y este catálogo todavía
 * no conozca: mostrar "DESPACHO" es mejor que mostrar un guion o una fila en blanco.
 */

export const TIPO_INGRESO = 'INGRESO';
export const TIPO_RESERVA = 'RESERVA';
export const TIPO_UTILIZACION = 'UTILIZACION';
export const TIPO_LIBERACION = 'LIBERACION';

export const TIPOS_DE_MOVIMIENTO = [TIPO_INGRESO, TIPO_RESERVA, TIPO_UTILIZACION, TIPO_LIBERACION];

export const etiquetaDeTipo = (intl, tipo) => {
	// Los ids van literales y no por variable: `formatjs extract` no resuelve un id que llega por
	// parámetro, y la clave quedaría fuera del catálogo de traducciones.
	if (tipo === TIPO_INGRESO) {
		return intl.formatMessage({ id: 'inventarioMovimientos.tipo_ingreso', defaultMessage: 'Ingreso' });
	}

	if (tipo === TIPO_RESERVA) {
		return intl.formatMessage({ id: 'inventarioMovimientos.tipo_reserva', defaultMessage: 'Reserva' });
	}

	if (tipo === TIPO_UTILIZACION) {
		return intl.formatMessage({ id: 'inventarioMovimientos.tipo_utilizacion', defaultMessage: 'Utilización' });
	}

	if (tipo === TIPO_LIBERACION) {
		return intl.formatMessage({ id: 'inventarioMovimientos.tipo_liberacion', defaultMessage: 'Liberación' });
	}

	return tipo || '-';
};
